/* Nizhoni Ranch Gallery theme: drawer, search, gallery, lightbox, filters. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toggle(el, on) { if (!el) return; el.classList.toggle('on', on); document.documentElement.style.overflow = on ? 'hidden' : ''; }

  var drawer = $('#drawer'), pop = $('#search-pop'), lb = $('#lb');
  $$('[data-open-drawer]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); toggle(drawer, true); }); });
  $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); toggle(pop, true); setTimeout(function () { $('input[name=q]', pop).focus(); }, 30); }); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target.classList.contains('shade') || e.target === pop) { toggle(drawer, false); toggle(pop, false); }
    if (e.target.closest('#lb')) toggle(lb, false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { toggle(drawer, false); toggle(pop, false); toggle(lb, false); } });

  // product gallery
  var stage = $('#stage img');
  $$('.thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.thumbs img').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on'); stage.src = t.dataset.big; stage.dataset.zoom = t.dataset.zoom;
    });
  });
  if (stage) $('#stage').addEventListener('click', function () { $('img', lb).src = stage.dataset.zoom || stage.src; toggle(lb, true); });

  // collection: sort select and native filter checkboxes submit the form
  var ff = $('#filter-form');
  if (ff) $$('input[type=checkbox]', ff).forEach(function (c) { c.addEventListener('change', function () { ff.submit(); }); });
  var sort = $('#sort');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  var ft = $('.filter-toggle');
  if (ft) ft.addEventListener('click', function () { $('.shop .filters').classList.toggle('on'); });
  var more = $('.more-btn');
  if (more) more.addEventListener('click', function () { $('.coll-desc').classList.remove('clamp'); more.remove(); });
})();
